const LEGACY_HOME_LOGIN_MODES = ['activated', 'updated', 'verifyEmail']

export const getLegacyHomeLoginSearch = (mode, token) => {
  if (!LEGACY_HOME_LOGIN_MODES.includes(mode)) return {}

  if (mode === 'verifyEmail' && token) {
    return { mode, token }
  }

  return { mode }
}
